/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_History_LabelInputs */

const en_us2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workouts with this exercise`)
};

const pt_br2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos com este exercício`)
};

const es_419_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamientos con este ejercicio`)
};

const pt_pt2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos com este exercício`)
};

const fr_fr2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances avec cet exercice`)
};

const de_de2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings mit dieser Übung`)
};

const it_it2_exercise_sheet_history_label = /** @type {(inputs: Exercise_Sheet_History_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamenti con questo esercizio`)
};

/**
* | output |
* | --- |
* | "Workouts with this exercise" |
*
* @param {Exercise_Sheet_History_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_history_label = /** @type {((inputs?: Exercise_Sheet_History_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_History_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_history_label(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_history_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_history_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_history_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_history_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_history_label(inputs)
	return en_us2_exercise_sheet_history_label(inputs)
});
export { exercise_sheet_history_label as "exercise-sheet.history_label" }